'use strict';
module.exports = require('../../full/symbol/for');
